import { z } from 'zod';
import { ChannelId } from './common.js';

/**
 * A channel as third parties see it.
 *
 * Note what is absent and stays absent: no viewer counts, no rankings, no
 * "worth" or valuation of anything (ADR 0030). There is nowhere in this shape
 * to put a number that would invite comparison between channels, which is a
 * product constraint with a schema consequence.
 */
export const Channel = z.object({
  id: ChannelId,
  slug: z.string().min(2).max(40),
  display_name: z.string().min(1).max(80),
  avatar_url: z.string().url().nullable(),
  description: z.string().max(500).nullable(),
  /** Live state, from the connector. Not a metric — a fact about right now. */
  live: z.object({
    is_live: z.boolean(),
    title: z.string().nullable(),
    category: z.string().nullable(),
    started_at: z.string().datetime().nullable(),
  }),
  created_at: z.string().datetime(),
});

export const ChannelPatch = z.object({
  display_name: z.string().min(1).max(80).optional(),
  description: z.string().max(500).nullable().optional(),
});

export type Channel = z.infer<typeof Channel>;
